import {
  type Context,
  createContext,
  type Dispatch,
  type SetStateAction,
} from 'react';

import type { ChipOwnProps } from '../../chip/types/chip.js';
import type { ChipGroupReducerActions } from '../state/chip-group-state-reducer.js';

/** @internal */
export type InternalChipGroupContextProps =
  | {
      chipGroupId?: string;
      expanded?: boolean;
      disabled?: boolean;
      size?: ChipOwnProps['size'];
      allChipsFit?: boolean;
      dispatch: Dispatch<ChipGroupReducerActions>;
      setExpanded: Dispatch<SetStateAction<boolean>>;
    }
  | undefined;

/**
 * The _InternalChipGroupContext provides access to required states and callbacks.
 * @internal
 */
export const InternalChipGroupContext: Context<InternalChipGroupContextProps> =
  createContext<InternalChipGroupContextProps>(undefined);
